import { ActionTypes } from './actions';

export const authenticationRequest = () => ({ type: ActionTypes.AUTHENTICATION_REQUEST });